export default "__VITE_ASSET__BK9aW6TG__"